<template>
  <div class="gray-page">
    <div class="relation-item">
      <img :src="master.src" class="head-img" />
      <div class="info-content">
        <!-- {{master.student_name}}  -->
        <div class="name">学生--{{$FilterCode('Family', master.kinship)}}</div>
        <div class="time">关注日期<span>{{master.bind_time}}</span></div>
        <div class="identity manager">管理员</div>
      </div>
    </div>
    <div class="relation-item" v-for="(item, index) in family" :key="index">
      <img :src="item.src" class="head-img" />
      <div class="info-content">
        <div class="name">学生--{{$FilterCode('Family', item.kinship)}}</div>
        <div class="time">关注日期<span>{{item.bind_time}}</span></div>
        <div class="identity">亲属</div>
      </div>
      <div class="cancel">
        <Btn title="取消关注" type="hollow" size="md" v-show="item.allow_delete" @click="CancelLook(item.id)" />
      </div>
    </div>
    <!-- <div class="relation-item">
      <img :src="Family2" class="head-img" />
      <div class="info-content">
        <div class="name">学生--奶奶</div>
        <div class="time">关注日期<span>2109-09-09</span></div>
        <div class="identity">亲属</div>
      </div>
      <div class="cancel">
        <Btn title="取消关注" type="hollow" size="md" @click="CancelLook" />
      </div>
    </div>
    <div class="relation-item">
      <img :src="Family1" class="head-img" />
      <div class="info-content">
        <div class="name">学生--爷爷</div>
        <div class="time">关注日期<span>2109-09-09</span></div>
        <div class="identity">亲属</div>
      </div>
      <div class="cancel">
        <Btn title="取消关注" type="hollow" size="md" @click="CancelLook" />
      </div>
    </div>
    <div class="relation-item">
      <img :src="Family7" class="head-img" />
      <div class="info-content">
        <div class="name">学生--其他</div>
        <div class="time">关注日期<span>2109-09-09</span></div>
        <div class="identity">亲属</div>
      </div>
      <div class="cancel">
        <Btn title="取消关注" type="hollow" size="md" @click="CancelLook" />
      </div>
    </div> -->

    <!-- 添加按钮 -->
    <Btn title="添加亲属" @click="add_show = true" v-show="master.allow_add"/>
    <van-popup v-model="add_show" :style="{ borderRadius: '.1rem' }">
      <AddPopup :master="master" @refresh="refresh" @close="add_show = false" />
    </van-popup>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  import AddPopup from './components/AddPopup'
  export default {
    data () {
      return {
        add_show: false,
        master: {},
        family: []
      }
    },
    methods: {
      CancelLook (id) {
        this.$ShowConfirm('确认要取消关注吗？').then(() => {
          this.$Post('Common.delFamily', { id }).then(res => {
            this.$ShowToast(res.msg, { icon: 'success' }).then(res => {
              this.GetList()
            })
          })
        })
      },
      GetList () {
        this.$Get('Common.getList', {
          cup_id: this.$route.query.id
        }).then(res => {
          this.master = {
            ...res.data.master,
            src: this['Family' + this.$FilterCode('Family', res.data.master.kinship, 'imgcode')]
          }
          this.family = res.data.family.map(item => ({
            ...item,
            src: this['Family' + this.$FilterCode('Family', item.kinship, 'imgcode')]
          }))
        })
      },
      refresh () {
        this.add_show = false
        this.GetList()
      }
    },
    mounted () {
      this.GetList()
    },
    computed: {
      ...SetImage('1'.repeat(7).split('').map((item, index) => `Family${index + 1}`))
    },
    components: {
      AddPopup
    }
  }
</script>

<style lang="less" scoped>
  .gray-page {
    .p(.3rem .24rem);
    .relation-item {
      .br(.1rem);
      .bg(#fff);
      .mb(.24rem);
      .h(2.08rem);
      display: flex;
      .pl(.24rem);
      align-items: center;
      position: relative;
      box-shadow: 0rem 0.02rem 0.29rem 0.01rem rgba(0, 0, 0, 0.06);
      & + button {
        .mt(.77rem);
      }
      .cancel {
        .w(1.4rem);
        position: absolute;
        bottom: .39rem;
        right: .24rem;
      }
      .head-img {
        .w(1.6rem);
        .h(1.6rem);
        .mr(.24rem);
      }
      .info-content {
        .name {
          .fz(.26rem);
          .c(#333);
          .mb(.23rem);
        }
        .time {
          .fz(.26rem);
          .c(#999);
          .mb(.23rem);
          span {
            .ml(.24rem);
            .c(#333);
          }
        }
        .identity {
          display: inline-block;
          .p(.08rem .21rem);
          .br(.17rem);
          .bg(#dbf5ff);
          .c(#00b0f4);
          .fz(.2rem);
          &.manager {
            .bg(#e2fffc);
            .c(#007f70);
          }
        }
      }
    }
  }
</style>
